import $ from 'jquery';
import {is_mobile_nav} from "../commons/helpers";
import {gsap} from "gsap";
import {debounce} from "lodash/function";

// Elements
const $links_depth_1 = $("nav#nav-main a[data-menulevel='1']");
const $menu_wrapper = $('#main-header-menu-wrapper');
const $main_header = $('#main-header');

// Objet contenant les timelines d'animations pour l'affichage des menus en mode mobile
let gsapSubMenusTimelinesObj = {};
let gsapMobileNavTimeline = null;

let currentSubMenuOpened = null;

const init_menu_navigation = () => {
    // Events
    $links_depth_1.on('click', (e) => click_menu_nav_depth_1_handler(e));

    const li_with_submenu = $('nav#nav-main>ul>li');
    li_with_submenu.on('mouseenter', (e) => mouse_enter_desktop_li(e))
    li_with_submenu.on('mouseleave', (e) => mouse_leave_desktop_li(e))

    /*$('nav#nav-main>ul>li.has-sub-menu ul.sub-menu.has-sub-menu-image .menu-image img')
        .one("load", (e) => resize_image_menu_handler(e))
        .each( (index, el) => {
            if(el.complete){
                el.trigger( "load" )
            }
        })*/

    $main_header.on('mobile-nav-toggle', () => {
        if (gsapMobileNavTimeline.reversed()) {
            // $("#nav-main").scrollTop(0);
            gsapMobileNavTimeline.play()
        } else {
            gsapMobileNavTimeline.reverse()
        }
    });

    $(window).on('resize', debounce(resizeWindowHandler, 150));
    setTimeout(()=>resizeWindowHandler(), 150)
    // resizeWindowHandler();
}


/**
 * Show/hide mobile sub menu
 * @param link
 */
const toggleMobileSubMenu = (link) => {
    const indice = link.data('num');
    const tl = gsapSubMenusTimelinesObj[indice];
    if (currentSubMenuOpened && indice !== currentSubMenuOpened) {
        const tlToReverse = gsapSubMenusTimelinesObj[currentSubMenuOpened];
        $(`nav#nav-main a[data-menulevel='1'][data-num='${currentSubMenuOpened}']`).removeClass('sub-menu-opened')
        tlToReverse.reverse();
    }
    if (tl.reversed()) {
        currentSubMenuOpened = indice
        link.addClass('sub-menu-opened');
        tl.play();
    } else {
        currentSubMenuOpened = null
        link.removeClass('sub-menu-opened');
        tl.reverse();
    }
}

/**
 * Défini les timelines d'animation pour les sous menus
 * @returns {{}}
 */
const defineMobileSubMenuTimelines = () => {
    let timelines = {};
    $links_depth_1.each((index, el) => {
        const $link = $(el);
        if ($link.hasClass('has-sub-menu')) {
            const indice = $link.data('num');
            const innerMenu = $link.parent();
            timelines[indice] = gsap.timeline({reversed: true, paused: true})
                .to(innerMenu, {height: "auto", duration: .5, ease: "power1.out"});
        }
    });
    return timelines;
}

/**
 * Handler de click sur les liens de niveaux 1
 * @param e
 */
const click_menu_nav_depth_1_handler = (e) => {
    const $link = $(e.currentTarget);
    const has_submenu = $link.hasClass('has-sub-menu');
    if (has_submenu) {
        e.preventDefault();
        if (is_mobile_nav()) {
            toggleMobileSubMenu($link);
        }
    }
}

const mouse_enter_desktop_li = (e) => {
    if (!is_mobile_nav()) {
        resizeDesktopWindow()
        const $li = $(e.currentTarget),
            $subMenu = $li.find("div.wrapper-sub-menu");
        $li.addClass('desktop-over');
        if($subMenu.length > 0){
            gsap.set($subMenu, {autoAlpha: 1})
        }
    }
}
const mouse_leave_desktop_li = (e) => {
    if (!is_mobile_nav()) {
        const $li = $(e.currentTarget),
            $subMenu = $li.find("div.wrapper-sub-menu");
        $li.removeClass('desktop-over');
        if($subMenu.length > 0){
            gsap.set($subMenu, {autoAlpha: 0})
        }
    }
}

const resizeWindowHandler = () => {
    if (is_mobile_nav()) {
        resizeMobileWindow();
    } else {
        resizeDesktopWindow();
    }
}
const resizeDesktopWindow = () => {
    // console.log("resize Desktop Window");
    gsap.set(["#nav-main>ul>li", '#main-header-cta-wrapper', '#nav-main', '#main-header-menu-wrapper', '.inner-menu'], {clearProps: 'all'});
    // console.log("calcul de la largeur des sous menus");

    // on calcul la largeur/hauteur total des sous menu si il y a une image
    $('nav#nav-main>ul>li.has-sub-menu ul.sub-menu.has-sub-menu-image').each((index, el) => {

        const container = $(el).parent();
        //const image = $(el).find('li.li-image-menu div.menu-image img');
        const border_wrapper = container.parent();
        const yPaddingBorderWrapper = border_wrapper.innerHeight() - border_wrapper.height();

        const container_width = container.outerWidth();
        const container_margin = container.outerWidth(true) - container.outerWidth();
        const container_padding = container.innerWidth() - container.width();

        const li_with_image = $(el).children("li.li-image-menu");

        const image_menu_width =  368;
        const image_menu_height =  348;

        // L'image de sous menu a toujours la même largeur
        let menu_height = $(el).height() + yPaddingBorderWrapper;
        const globalSubMenuLink= $(el).next("div.global-sub-menu-link");
        if(globalSubMenuLink.length > 0){
            // console.log(el);
            // console.log(globalSubMenuLink);
            // console.log(globalSubMenuLink.innerHeight());
            menu_height += globalSubMenuLink.innerHeight()

        }

        if( menu_height < image_menu_height) {
            const diff = image_menu_height - menu_height;
            $(el).css('marginBottom', diff);
        }else{
            const diff = menu_height - image_menu_height,
                newHeight = image_menu_height + diff;
            li_with_image.height(newHeight);
        }

        // on force la largeur du menu
        $(el).width(container_width - image_menu_width + (container_margin / 2) - (container_padding))
        if(globalSubMenuLink.length > 0){
            globalSubMenuLink.width(container_width - image_menu_width + (container_margin / 2) - (container_padding))
        }

    })
}
const resize_image_menu_handler = (e) => {
    console.log("resize_image_menu_handler");
    const $imageLoaded = $(e.currentTarget);
    console.log($imageLoaded);
}
const resizeMobileWindow = () => {
    gsap.set(["#nav-main>ul>li", '#main-header-cta-wrapper', '#nav-main', '#main-header-menu-wrapper', '.wrapper-sub-menu'], {clearProps: 'all'});
    $('nav#nav-main>ul>li.has-sub-menu ul.sub-menu.has-sub-menu-image').each((index, el) => {
        $(el).width('auto');
    })

    let previous_reversed = true;
    if (gsapMobileNavTimeline) {
        previous_reversed = gsapMobileNavTimeline.reversed()
        gsapMobileNavTimeline.kill();
    }
    // Définition d'une nouvelle timeline globale
    gsapMobileNavTimeline = defineMobileMainMenuTimeline(previous_reversed)

    // Définition des anim pour les sous menu
    if (Object.entries(gsapSubMenusTimelinesObj).length === 0) {
        gsapSubMenusTimelinesObj = defineMobileSubMenuTimelines();
    }
    // si le menu est ouvert (previous_reversed == false)
    if (!previous_reversed) {
        gsapMobileNavTimeline.totalProgress(1);
    } else {
        gsapMobileNavTimeline.totalProgress(0);
    }
}

/**
 * Calcul et retourne la hauteur max que doit avoir le menu en mode mobile
 * @returns {string}
 */
const getMaxHeightMainMobileMenu = () => {
    const windows_height = window.innerHeight;
    const brand_height = $('#main-header-brand-wrapper').innerHeight(); //ok
    const header_padding = parseInt($main_header.css('paddingTop'), 10) + parseInt($main_header.css('paddingBottom'), 10);
    const header_height = brand_height + header_padding;
    const diff = windows_height - header_height - (header_padding / 2);
    return diff + "px";
}

/**
 * Définition de la timeline d'animation pour l'affichage du menu mobile
 * @param reversed {boolean}
 * @returns {gsap.core.Timeline}
 */
const defineMobileMainMenuTimeline = (reversed) => {
    if (is_mobile_nav()) {
        return gsap.timeline({reversed: reversed, paused: true})
            .fromTo('#main-header-menu-wrapper', {paddingTop: '0px'}, {paddingTop: 56, duration: .35, ease: "power1.out"})
            .fromTo('#nav-main', {height: '0px'}, {height: getMaxHeightMainMobileMenu, duration: .35, ease: "power1.out"}, '-=0.35')
            .fromTo(["#nav-main>ul>li", '#main-header-cta-wrapper'], {y: +50, autoAlpha: 0,}, {y: 0, autoAlpha: 1, duration: .5, ease: "power1.out", stagger: 0.05}, '-=0.25');
    }
    return null;

}

export {init_menu_navigation};